import {getTestProps} from '@benchling/js-test-utils';
import {Stack, Text} from '@mantine/core';
import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {chatSettingsModalUrl} from 'llm/routes/UrlUtils';
import useRoutine from 'llm/routines/useRoutine';

import {ChatSettingsTab} from '../AISidepanelV2GlobalClientState';

/** Opens the agent's configuration in the chat settings modal, which portals out of the sidepanel. */
export function navigateToAgentConfiguration(routineId: string): void {
  navigateToURL(chatSettingsModalUrl(ChatSettingsTab.AGENTS, {selectedItemId: routineId}));
}

/**
 * The header title for the Agent homepage: the agent's name as the page's level-1 heading. Renders
 * nothing until the routine resolves, so callers can place it in a plain layout slot.
 */
export function RoutineHomepageHeaderTitle({routineId}: {routineId: string}): JSX.Element | null {
  const {routine} = useRoutine({routineId});
  if (routine == null) {
    return null;
  }
  const name = routine.name ?? 'Agent';

  return (
    <Stack
      align="center"
      aria-label={name}
      aria-level={1}
      miw={0}
      role="heading"
      spacing={0}
      {...getTestProps({component: 'RoutineHomepageHeaderTitle', element: 'root'})}
    >
      <Text fw={600} miw={0} size="md" truncate={true}>
        {name}
      </Text>
    </Stack>
  );
}
